import { Component, OnInit, Input, ChangeDetectorRef, Output, EventEmitter, TemplateRef, ContentChild, ElementRef } from '@angular/core';
import { GalleryColumns } from 'src/app/gallery/models/gallery-list-columns.enum';
import { MatCheckboxChange } from '@angular/material';
import { BookmarkModel } from 'src/app/bookmarks/models/bookmark.model';

@Component({
  selector: 'app-gallery-list',
  templateUrl: './gallery-list.component.html',
  styleUrls: ['./gallery-list.component.scss']
})
export class GalleryListComponent implements OnInit {
  @ContentChild('galleryActions', { read: TemplateRef }) 
  @Input()
  galleryActionsTemplate: TemplateRef<ElementRef>;

  @ContentChild('galleryTags', { read: TemplateRef }) 
  @Input()
  galleryTagsTemplate: TemplateRef<ElementRef>;

  @Input()
  selectLabel = 'Select';

  @Input()
  public get columns(): GalleryColumns[] {
    return this._columns;
  }
  public set columns(value: GalleryColumns[]) {
    this._columns = value;
  }
  private _columns: GalleryColumns[] = [
    GalleryColumns.Model,
    GalleryColumns.Tags,
    GalleryColumns.CreatedBy,
    GalleryColumns.UpdatedBy,
    GalleryColumns.Actions
  ];

  @Input()
  public get results(): BookmarkModel[] {
    return this._results;
  }
  public set results(value: BookmarkModel[]) {
    this._results = value;
    this.changeDetectorRef.markForCheck();
  }
  private _results: BookmarkModel[];

  @Input()
  showActions = false;

  @Input()
  checkable = false;

  @Input()
  checkedResults: string[] = [];

  @Output()
  checkedChange = new EventEmitter<string[]>();

  @Output()
  selectBookmark = new EventEmitter<BookmarkModel>();

  constructor(
    private changeDetectorRef: ChangeDetectorRef
  ) { }

  ngOnInit() {
  }

  handleSelect(result: BookmarkModel) {
    this.selectBookmark.emit(result);
  }

  handleCheckedChange(event: MatCheckboxChange) {
    const ids = (event.checked) ? [...this.checkedResults, event.source.value] : this.checkedResults.filter(id => id !== event.source.value);
    this.checkedChange.emit(ids);
  }

  isChecked(id: string) {
    return this.checkedResults.indexOf(id) >= 0;
  }
}
